import { Image } from "@/components/ui/image";

const LOGO_URL =
  "https://media.base44.com/images/public/6a80a7f0e10008ea488688fc/b77a426c3_ChatGPTImageAug18202609_51_12PM.png";

export default function Logo({ className = "", href = "#top" }) {
  return (
    <a href={href} aria-label="Meridian Bed Bug Pest Control" className={`inline-flex items-center rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}>
      <Image
        src={LOGO_URL}
        alt="Meridian Bed Bug Pest Control"
        fittingType="fit"
        loading="eager"
        className="h-12 w-auto lg:h-14"
      />
    </a>
  );
}